import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import 'src/app/components/Checkbox.scss';


const Checkbox = React.forwardRef((props, ref) => {
  const { validationMessage, checked, required, children, disabled, ...other } = props;

  const classList = classNames({
    'checkbox': true,
    'checkbox--invalid': !!validationMessage,
    'checkbox--checked': checked,
    'checkbox--disabled': disabled
  });

  const descriptionClassList = classNames({
    'checkbox__description': true,
    'description': true
  });

  return (
    <label styleName={ classList }>

      <input type="checkbox"
             styleName="checkbox__input"
             required={ required }
             ref={ ref }
             disabled={ disabled }
             {
               ...other
             }
      />

      <span styleName="checkbox__visualization"/>

      <span styleName={ descriptionClassList }>
        <span styleName="description__copy">
          {children}
        </span>

        <span styleName="description__validation" data-test="validation-summary-errors">
          {validationMessage}
        </span>
      </span>
    </label>
  );
});

Checkbox.propTypes = {
  children: PropTypes.node,
  validationMessage: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  required: PropTypes.bool
};

Checkbox.defaultProps = {
  required: false,
  validationMessage: ''
};

export default Checkbox;
